export default __webpack_public_path__ + "static/media/icon-mexico-location.6dba3d7a.svg";